let pendingShowInstructions = false;

function onReload(ev) {
    onReset(ev);
    clearUuid();
    pendingShowInstructions = false;
    showUploadInput();
}

function imageLoadedDnd(img) {
    replaceInputImage(img);
    imageLoaded(img);
}

function imageLoaded(img) {

    hideMessage();

    if (img) {

        if (isInvalidImage(img, function(error) {showError(error);})) {
            return;
        }

        if (img.type === 'image/heif' || img.type === 'image/heic') {
            showMainSpinner();
            loadHeifImage(img, 
                function(pngFile) {
                    replaceInputImage(pngFile);
                    pendingShowInstructions = true;
                    loadPreviewImage(pngFile);
                    hideMainSpinner();
                },
                function(error) {
                    hideMainSpinner();
                    reportHeifError(window.PM_CONFIG.apiUrl, getUuid(), 'paint-by-numbers', img, error,
                        function(response) { setUuid(response.uuid); },
                        function() {});
                    showError("pbn.start_error_loading_image");
                }
            );
        }
        else {
            pendingShowInstructions = true;
            loadPreviewImage(img);
        }
    }
    else {
        showError("pbn.start_invalid_image_format");
    }
}

// Show the upload instructions overlay only after a user-initiated image
// selection has finished rendering into the preview container.
document.addEventListener('pm:preview-shown', function() {
    if (pendingShowInstructions) {
        pendingShowInstructions = false;
        if (!getUploadInstructionsShown()) {
            showUploadInstructions();
        }
    }
});

function onCloseUploadInstructionsPreview(ev) {
    ev.preventDefault();
    setUploadInstructionsShown();
    hideUploadInstructions();
}

function showUploadInput() {
    let uploadContainer = $('.pm-upload-container');
    uploadContainer.removeClass("pm-invisible");
    $("#input_image").val("");

    hideMainSpinner();
    showCodeDialog('pbn', true, function() {
        scrollPreviewIntoView();
    });
}

function onContinue(ev) {
    ev.preventDefault();

    hideMessage();
    showMainSpinner();
    const uuid = getUuid();
    const apiUrl = window.PM_CONFIG.apiUrl + '/upload-paint-by-numbers/' + uuid;
    upLoadImage(apiUrl, 
        function(response) {
            setUuid(response.uuid);
            window.location.href = response.skip ? '/preview-painting' : '/select-painting-color';
        },
        function(jqXHR, textStatus, errorThrown) {
            console.log(textStatus + '-' + errorThrown);
            hideMainSpinner();
            if (jqXHR.responseJSON && jqXHR.responseJSON.clear) {
                clearUuid();
                removeCode();
                window.location.href = '/start-paint-by-numbers';
            }
            if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                showError(jqXHR.responseJSON.error);
            }
            else {
                showError("pbn.start_error_loading_image");
            }
        }
    );
}

window.addEventListener('DOMContentLoaded', function(ev) {       
    ev.preventDefault();
    
    ASPECT_PORTRAIT = 0.75;
    ASPECT_LANDSCAPE = 1.33;
    // ZOOM_OUT_RATIO = 0.85;

    showUploadInput();

    scrollPreviewIntoView();
    requestAnimationFrame(fitPreviewContainerToScreen);
});
